module.exports = __webpack_public_path__ + "static/media/SFC Input.99490e75.png";